import React from 'react';
import { Download, Headphones } from 'lucide-react';
import { getDownloadUrl } from '../../utils/mediaUtils';

const btnCls =
  'flex items-center justify-center gap-2 px-4 py-3 border border-slate-300 bg-white text-slate-700 font-body font-medium text-sm rounded hover:border-brand-accent hover:text-brand-accent transition-colors duration-300';

const safeName = (title) => title.replace(/[^\w\s()-]/g, '').trim();

export const FeaturedDownloads = ({ video }) => {
  const name = safeName(video.title);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="featured-downloads">
      <a href={getDownloadUrl(video.video_url, `${name}.mp4`)} className={btnCls} data-testid="featured-download-video">
        <Download className="h-4 w-4" /> Download Video (MP4)
      </a>
      <a href={getDownloadUrl(video.audio_url, `${name}.mp3`)} className={btnCls} data-testid="featured-download-audio">
        <Headphones className="h-4 w-4" /> Download Audio
      </a>
    </div>
  );
};
